<template>
  <ContentWrap>
    <el-form :inline="true" :model="queryParams">
      <el-form-item label="商品名称">
        <el-input
          v-model="queryParams.spuName"
          class="!w-220px"
          clearable
          placeholder="商品名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="回复状态">
        <el-select v-model="queryParams.replyStatus" class="!w-140px" clearable placeholder="全部">
          <el-option label="未回复" :value="false" />
          <el-option label="已回复" :value="true" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon icon="ep:search" class="mr-5px" />搜索</el-button>
        <el-button @click="resetQuery"><Icon icon="ep:refresh" class="mr-5px" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="商品" prop="spuName" min-width="160" show-overflow-tooltip />
      <el-table-column label="评价人" prop="userNickname" width="120" />
      <el-table-column label="评分" prop="scores" width="70" />
      <el-table-column label="内容" prop="content" min-width="200" show-overflow-tooltip />
      <el-table-column label="回复" width="90">
        <template #default="{ row }">
          <el-tag v-if="row.replyStatus" type="success">已回复</el-tag>
          <el-tag v-else type="info">未回复</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="回复方" width="90">
        <template #default="{ row }">
          {{ replySideLabel(row.replyUserType, row.replyStatus) }}
        </template>
      </el-table-column>
      <el-table-column label="评价时间" prop="createTime" width="170" :formatter="dateFormatter" />
      <el-table-column label="操作" width="90" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openReply(row)">回复</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <el-dialog v-model="replyVisible" title="回复评价" width="480px">
    <div class="mb-12px text-13px text-gray-500">{{ current?.content }}</div>
    <el-input v-model="replyContent" :rows="4" type="textarea" maxlength="500" show-word-limit />
    <template #footer>
      <el-button @click="replyVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitReply">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import * as CommentApi from '@/api/merchant/product/comment'
import { dateFormatter } from '@/utils/formatTime'

defineOptions({ name: 'MerchantProductComment' })

const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  spuName: '',
  replyStatus: undefined as boolean | undefined
})

const replyVisible = ref(false)
const submitting = ref(false)
const replyContent = ref('')
const current = ref<any>(null)

const replySideLabel = (type?: number, replied?: boolean) => {
  if (!replied) return '—'
  return type === 1 ? '商家' : '平台'
}

const getList = async () => {
  loading.value = true
  try {
    const data = await CommentApi.getCommentPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryParams.spuName = ''
  queryParams.replyStatus = undefined
  handleQuery()
}

const openReply = (row: any) => {
  current.value = row
  replyContent.value = row.replyContent || ''
  replyVisible.value = true
}

const submitReply = async () => {
  if (!replyContent.value.trim()) {
    message.warning('请填写回复内容')
    return
  }
  submitting.value = true
  try {
    await CommentApi.replyComment({ id: current.value.id, replyContent: replyContent.value.trim() })
    message.success('已回复')
    replyVisible.value = false
    await getList()
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  getList()
})
</script>
